const defaults = {
    easing: "ease",
    duration: 500,
    fill: "none"
};
export const buildAnimation = ({ frames, targetElement, options = {} }) => {
    return targetElement.animate(frames, { ...defaults, ...options });
};
export const getHeight = (element) => {
    return element.getBoundingClientRect().height;
};
export const fireCustomEvent = ({ oldStep, newStep, element, name }) => {
    const event = new CustomEvent(name, {
        detail: {
            oldStep, newStep, element
        }
    });
    element.dispatchEvent(event);
};
export const afterRepaint = (cb) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            cb();
        });
    });
};
export const isMovingBackward = (direction) => {
    return direction === 'backward';
};
export const flip = (items) => {
    return [...items].reverse();
};
